/**
 * 考核
 * */
import util from '@/utils/common';
export default {
  namespaced: true,
  state: {
    appraiseHistory: [], // 浏览记录
    appraiseKeyword: [], // 搜索记录
    negativeSummary: util.getJsonLocal('negativeSummary'),  //  新增舆情概况
    negativeDesc: util.getJsonLocal('negativeDesc'),  // 舆情详细描述
    negativeCitys: util.getJsonLocal('negativeCitys'),  // 舆情所涉州市
    currentQuarter: util.getJsonLocal('currentQuarter'),  // 批量审核页面记录当前选中季度
    eCategoryList:[],
  },
  mutations: {
    setNegativeSummary: (state, data) => {
      state.negativeSummary = data;
      util.setJsonLocal('negativeSummary', data);
    },
    setNegativeDesc: (state, data) => {
      state.negativeDesc = data;
      util.setJsonLocal('negativeDesc', data);
    },
    setNegativeCitys: (state, data) => {
      state.negativeCitys = data;
      util.setJsonLocal('negativeCitys', data);
    },
    setCurrentQuarter: (state, data) => {
      state.currentQuarter = data;
      util.setJsonLocal('currentQuarter', data);
    },
    setECategoryList: (state, data) => {
      state.eCategoryList = data;
    },
  },
  actions: {
      /**
       * @description 设置查看的浏览记录
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       * @param {*} info info
       */
      setHistory ({ state, dispatch }, info) {
          return new Promise(async resolve => {
              // store 赋值
              state.appraiseHistory = info;
              // 持久化
              await dispatch('db/set', {
                  dbName: 'database',
                  path: 'appraiseHistory',
                  value: info
              }, { root: true });
              // end
              resolve();
          })
      },

      /**
       * @description 从数据库取查看的浏览记录
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       */
      loadHistory ({ state, dispatch }) {
          return new Promise(async resolve => {
              // store 赋值
              state.appraiseHistory = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'appraiseHistory',
                  defaultValue: {}
              }, { root: true });
              // end
              resolve();
          })
      },
      /**
         * @description 设置搜索记录
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         * @param {*} info info
         */
        setKeyword ({ state, dispatch }, info) {
          return new Promise(async resolve => {
              // store 赋值
              state.appraiseKeyword = info;
              // 持久化
              await dispatch('db/set', {
                  dbName: 'database',
                  path: 'appraiseKeyword',
                  value: info
              }, { root: true });
              // end
              resolve();
          })
      },

      /**
       * @description 从数据库取搜索记录
       * @param {Object} state vuex state
       * @param {Object} dispatch vuex dispatch
       */
      loadKeyword ({ state, dispatch }) {
          return new Promise(async resolve => {
              // store 赋值
              state.appraiseKeyword = await dispatch('db/get', {
                  dbName: 'database',
                  path: 'appraiseKeyword',
                  defaultValue: {}
              }, { root: true });
              // end
              resolve(state.appraiseKeyword);
          })
      }
  }
}
